<script setup lang="ts">
</script>

<template>
	<div class="top-islandRows_row">
		<slot></slot>
	</div>
</template>

<style>
.top-islandRows_row {
	outline-offset: 2px;
	border-radius: 8px;
	background: var(--color-layout-front-1);
	padding: var(--top-padding-3);
	display: flex;
	gap: var(--top-gap-2);
}

/* Фокус форм */
.top-islandRows_row:has(> .top-forms-optionWrapper .top-forms-focusable:focus-visible) {
	outline: 2px solid var(--color-line-primary-1);
	outline-offset: 2px;
}

/* Фокус форм, стили top-error оставить у форм, иначе они будут конфликтовать со стилями фокуса, так как у top-islandRows_row нет border */
.top-islandRows_row > .top-forms-optionWrapper .top-forms-focusable:not(.top-error) {
	outline: none;
	animation: none;
}

/* Отмена прозрачных рамок у полей ввода внутри islandRows, если top-rows расположен в islandRowsRow */
.top-islandRows_row .top-rows > .top-input,
.top-islandRows_row .top-rows > .top-textarea,
.top-islandRows_row .top-rows > .top-select { --top-forms-border-color: inherit }
</style>
